import { cx } from '@mage-ui/styled-system/css';
import {
  button,
  gridCol,
  imageHighlightCard,
  text,
  textStyles,
  title,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { isExternalLink } from 'utils/isExternalLink';
import { GridCol } from '../../layouts/grids/GridCol';
import { GridRow } from '../../layouts/grids/GridRow';

export const ImageHighlightCard = ({
  data,
  children,
  imgSize = 'large',
  ...props
}) => {
  const colImgM = imgSize === 'small' ? '6' : '8';
  const colTextM = imgSize === 'small' ? '6' : '4';
  const colImgL = imgSize === 'small' ? '4' : '8';
  const colTextL = imgSize === 'small' ? '8' : '4';
  const classes = imageHighlightCard();

  const ctaSlug = data?.cta_slug;
  const isExternal = isExternalLink(ctaSlug);
  return (
    <GridRow className={classes.root} {...props}>
      {children && (
        <GridCol
          className={cx(
            gridCol({ colSpanM: colImgM, colSpanL: colImgL }),
            classes.imgWrapper,
          )}
        >
          {children}
        </GridCol>
      )}
      <GridCol
        className={cx(
          gridCol({ colSpanM: colTextM, colSpanL: colTextL }),
          classes.contentWrapper,
        )}
      >
        <div className={classes.topContent}>
          <h2
            className={cx(title({ size: '5', weight: 'bold' }), classes.title)}
          >
            {data?.title}
          </h2>
          {data?.description && (
            <div
              className={cx(
                text({ size: '3', weight: 'medium' }),
                classes.description,
                textStyles({ color: 'primary' }),
              )}
              dangerouslySetInnerHTML={{ __html: data?.description || '' }}
            />
          )}
        </div>
        <div className={classes.bottomContent}>
          {data?.cta_description && (
            <div className={classes.ctaDescription}>
              <div
                className={cx(
                  text({ size: '2', weight: 'semiBold' }),
                  classes.description,
                  textStyles({ color: 'primary' }),
                )}
                dangerouslySetInnerHTML={{
                  __html: data?.cta_description || '',
                }}
              />
            </div>
          )}
          {ctaSlug && (
            <div className={classes.ctaWrapper}>
              <Link
                href={ctaSlug}
                className={button()}
                {...(isExternal && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
              >
                {data?.cta_text}
              </Link>
            </div>
          )}
        </div>
      </GridCol>
    </GridRow>
  );
};
